var date = {
  "abbr_day_names": ["dom", "lun", "mar", "mer", "gio", "ven", "sab"],
  "abbr_month_names": [null, "gen", "feb", "mar", "apr", "mag", "giu", "lug", "ago", "set", "ott", "nov", "dic"],
  "day_names": ["Domenica", "Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato"],
  "formats": {
    "default": "%d/%m/%Y",
    "long": "%e %B %Y",
    "short": "%d %b",
    "datepicker2": "%d %b %Y",
    "short_day": "%a %e %b",
    "month_year": "%b %Y",
    "day_only": "%d",
    "long_month_only": "%B",
    "long_year_only": "%Y",
    "long_month_year": "%B %Y",
    "myenlighten_month": "%m/%Y",
    "graph": {
      "long": "%a %e %b %Y",
      "x_axis": {
        "day": "%e-%b",
        "week": "%e-%b"
      }
    },
    "jquery": {
      "datepicker": "d/m/y",
      "datepicker2": "d M yy",
      "power_playback": "ddd d MMM yyyy HH:mm",
      "myenlighten": "dd/mm/yyyy",
      "datejs_formatter": "dd/M/yyyy",
      "myenlighten_month": "mm/yyyy",
      "myenlighten_overview": "D d M yyyy",
      "datejs_month_formatter": "M/yyyy"
    },
    "js": {
      "short_month": "%b",
      "short_day_year": "%a %e %b %Y",
      "short_month_day": "%e&nbsp;%B&nbsp;%Y",
      "short_month_day_time": "%e %B %Y – %H:%M"
    }
  },
  "month_names": [null, "gennaio", "febbraio", "marzo", "aprile", "maggio", "giugno", "luglio", "agosto", "settembre", "ottobre", "novembre", "dicembre"],
  "order": ["day", "month", "year"],
  "range": {
    "presets": {
      "today": "Oggi",
      "last7Days": "Ultimi 7 giorni",
      "monthToDate": "Mese fino a oggi",
      "yearToDate": "Anno fino a oggi"
    }
  }
};
module.exports = date;